export enum AssetType {
  Truck = 1,
  Plane = 2,
  Boat = 3,
  Trailer = 4,
  Car = 5,
  Motorbike = 6,
  Generator = 7,
  Wagon = 8,
  ATG = 9,
  YellowEquipment = 10,
  Container = 11,
  SkyVault = 12,
  Van = 13
}